import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@glu/theming';
import uniqueId from 'lodash/uniqueId';
import withLocale from '../withLocale/withLocale';
import { JSSClasses } from '../../proptypes/jss-prop-types';
import styles from './radioButton.style';

export function convert(onChange, callback, name) {
  return ({ target: { value } }) => {
    if (typeof callback === 'function') {
      callback(name, value);
    } else {
      onChange(name, value);
    }
  };
}

export function RadioButtonComponent({
  className,
  classes: { radioContainer, radioVertical, radioWrapper, title: clsTitle, titleOnTop, wrapper },
  data,
  dataQa,
  disabled,
  name,
  onChange,
  onUpdate,
  settings,
  styled,
  title,
  value
}) {
  const [id] = useState(uniqueId());
  const [checked, setChecked] = useState({});

  const onCheckedChange = (name, value) => {
    setChecked((checked) => {
      onUpdate({ name, value });
      return {
        ...checked,
        [name]: value
      };
    });
  };

  // set initial state
  useEffect(() => {
    onUpdate({ name, value });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={classnames(wrapper, className, {
        [titleOnTop]: settings.titleOnTop,
        disabledRadioBtnContainer: disabled
      })}
      data-qa={dataQa}
    >
      {title && <p className={clsTitle}>{title}</p>}
      <div
        className={classnames(radioContainer, {
          [radioVertical]: settings.radioVertical,
          disabledRadioBtn: disabled
        })}
      >
        {data.map((item, index) => (
          <div key={item.value} className={classnames(radioWrapper, { styledRadioBtn: styled })}>
            <input
              id={`${id}_${item.value}_${index}`}
              type="radio"
              value={item.value}
              checked={(checked[name] || value) === item.value}
              onChange={convert(onCheckedChange, onChange, name)}
              disabled={disabled}
            />
            {styled && <span className="radioBtn" />}
            <label htmlFor={`${id}_${item.value}_${index}`}>{item.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
}

RadioButtonComponent.defaultProps = {
  classes: {},
  data: [],
  name: '',
  value: '',
  onChange: null,
  onUpdate() {},
  styled: false,
  settings: {},
  title: '',
  className: '',
  disabled: false,
  dataQa: ''
};

RadioButtonComponent.propTypes = {
  classes: JSSClasses,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  styled: PropTypes.bool,
  disabled: PropTypes.bool,
  onUpdate: PropTypes.func,
  settings: PropTypes.shape({}),
  title: PropTypes.string,
  className: PropTypes.string,
  dataQa: PropTypes.string
};

const Styled = withStyles(styles)(RadioButtonComponent);
export default withLocale(Styled);
